import React from 'react';
const tomos = [{
  color: '🟢',
  title: 'VOLUME 1',
  subtitle: 'Youth Netball U10-U12',
  desc: '40 complete sessions',
  features: 'Passing · Footwork · Position Basics · Coordination'
}, {
  color: '🟡',
  title: 'VOLUME 2',
  subtitle: 'Junior Netball U13-U15',
  desc: '40 complete sessions',
  features: 'Feeding Chain · Shooting & Defensive Pairs · Transitions'
}, {
  color: '🟠',
  title: 'VOLUME 3',
  subtitle: 'Advanced Netball U16-U19/Senior',
  desc: '40 complete sessions',
  features: 'Advanced Tactics · Defensive Systems · Game Management'
}, {
  color: '🔴',
  title: 'VOLUME 4',
  subtitle: 'Physical Conditioning Protocols',
  desc: 'Specific training programs',
  features: 'Speed · Agility · Landing Mechanics · Injury Prevention'
}, {
  color: '🟣',
  title: 'VOLUME 5',
  subtitle: '101 Shooting & Feeding Drills',
  desc: 'All categories',
  features: 'Classified by position and level'
}, {
  color: '⭐',
  title: 'VOLUME 6',
  subtitle: 'Scouting & Team Management',
  desc: 'Advanced coaching tools',
  features: 'Position-specific evaluations · Performance tracking · Communication'
}];
const features = ['Annual Planning', 'Complete Sessions', 'Ready-to-use Diagrams', 'Skill Progressions', 'Sessions by Age Group', 'Tracking Tools'];
export function WhatYouGet() {
  return <section className="w-full bg-white py-16 px-4" data-id="element-277">
      <div className="max-w-5xl mx-auto" data-id="element-278">
        <h2 className="text-3xl sm:text-5xl font-black text-[#0A0A0A] text-center mb-12 tracking-tight" data-id="element-279">
          The 6 Complete Volumes
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-280">
          {tomos.map(tomo => <div key={tomo.title} className="bg-white border border-[#E5E5EA] rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow flex flex-col" data-id="element-281">
              <div className="flex items-center gap-3 mb-4" data-id="element-282">
                <span className="text-2xl" data-id="element-283">{tomo.color}</span>
                <div data-id="element-284">
                  <h3 className="font-black text-[#0A0A0A] text-sm tracking-wider uppercase" data-id="element-285">
                    {tomo.title}
                  </h3>
                  <p className="text-[#6B2FB3] font-bold text-lg leading-tight" data-id="element-286">
                    {tomo.subtitle}
                  </p>
                </div>
              </div>
              <p className="text-[#0A0A0A] font-bold text-sm mb-2" data-id="element-287">
                {tomo.desc}
              </p>
              <p className="text-[#5A5A66] text-sm font-medium leading-relaxed mt-auto" data-id="element-288">
                {tomo.features}
              </p>
            </div>)}
        </div>

        <div className="bg-[#FAFAFA] border border-[#E5E5EA] rounded-2xl p-6 sm:p-8" data-id="element-289">
          <h4 className="text-center font-black text-[#0A0A0A] mb-6 uppercase tracking-wider text-sm" data-id="element-290">
            What every volume includes
          </h4>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-3 max-w-3xl mx-auto" data-id="element-291">
            {features.map(f => <span key={f} className="text-[#0A0A0A] text-sm font-bold flex items-center gap-2" data-id="element-292">
                <span className="text-[#00C853] text-lg flex-shrink-0" data-id="element-293">✅</span>
                <span data-id="element-294">{f}</span>
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}